import { Icon, IconProps } from "@chakra-ui/react";

export function HamburguerIcon({ ...rest }: IconProps) {
  return (
    <Icon
      width="16px"
      height="auto"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0 1H18.5M0 7.5H18.5M0 14H18.5"
        stroke="currentColor"
        strokeWidth="2"
      />
    </Icon>
  );
}
